import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppPreferences, Preference } from '../../shared/local/app-preferences.local';
import { RequestUserSubmitDto, ResponseWorklocationDto } from '../../shared/nestjs/gd-only/dto/worklocation.dto';
import { WorklocConfirmationNestApi } from '../../shared/nestjs/gd-only/services/workloc-confirmation.api';
import { WorklocationNestApi } from '../../shared/nestjs/gd-only/services/worklocation.api';
import { NestApiProvider } from '../../shared/nestjs/nest-api';
import { ResponsePaging } from '../../shared/nestjs/nest-responses';
import { WorkLocationApi } from '../../shared/sdk';

/*
	Generated class for the WorklocationServiceProvider provider.

	See https://angular.io/docs/ts/latest/guide/dependency-injection.html
	for more info on providers and Angular DI.
*/
@Injectable()
export class WorklocationServiceProvider {
	public subscriptions: Array<Subscription> = []
	constructor(
		private workLocationApi: WorkLocationApi,
		private worklocationNestApi: WorklocationNestApi,
		private nestApiProvider: NestApiProvider,
		private worklocConfirmationNestApi: WorklocConfirmationNestApi,
		private appPreferences: AppPreferences
	) {
		console.log('Hello WorklocationServiceProvider Provider');
	}

	findWorkLocation(payload: { page: number, limit: number, companyId: any }) {
		return new Promise<ResponsePaging<ResponseWorklocationDto>>(async (resolve, reject) => {
			this.subscriptions.push(
				this.apiFindWorklocation(payload).subscribe((result) => {
					resolve(result);
				}, error => {
					reject(error)
				})
			);
		})
	}

	private apiFindWorklocation(payload: { page: number, limit: number, companyId: any }): Observable<any> {
		return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
			.mergeMap(isGoPathNewExist => {
				if (isGoPathNewExist) {
					return this.worklocationNestApi.findWorkLocation(payload);
				} else {
					let item: any = {}
					return this.workLocationApi.findWorkLocation(payload).map((response) => {
						item.totalPage = 1;
						item.page = 1;
						item.total = response.length;
						item.limit = response.length;
						item.data = response;
					})
				}
			})
	}


	async todayForm() {
		const companySetting = this.appPreferences.dataAuth && this.appPreferences.dataAuth.companySetting;
		const worklocConfirm = companySetting && companySetting.wlc ? companySetting.wlc : false;

		if (worklocConfirm) {
			try {
				await this.appPreferences.setGreatdayStorage(Preference.GDAttendanceTodayFormIsLoading, true);
				const response = await this.worklocConfirmationNestApi.todayForm().toPromise();
				await this.appPreferences.setGreatdayStorage(Preference.GDAttendanceTodayForm, response.data);
			} finally {
				await this.appPreferences.setGreatdayStorage(Preference.GDAttendanceTodayFormIsLoading, false);
			}
		}
	}

	submitForm(payload: RequestUserSubmitDto) {
		return new Promise<void>(async (resolve, reject) => {
			this.subscriptions.push(
				this.worklocConfirmationNestApi.submitForm(payload)
					.subscribe(() => {
						resolve(null);
					}, error => {
						reject(error);
					})
			);
		})
	}

}



// WEBPACK FOOTER //
// ./src/providers/worklocation/worklocation.service.ts